import { Component } from '@angular/core';
import { Feature } from '@freelancer/feature-flags';
import { ButtonColor } from '@freelancer/ui/button';

@Component({
  selector: 'app-navigation-secondary-hire-freelancers',
  template: `
    <app-bar flTrackingSection="SubnavHireFreelancers">
      <app-bar-item
        link="/post-project"
        i18n="Secondary navigation hire bar item"
        flTrackingLabel="PostProjectButton"
        [exactLink]="true"
      >
        Post a Project
      </app-bar-item>
      <app-bar-item
        *flFeature="Feature.CONTEST_POST"
        link="/contest/create.php"
        i18n="Secondary navigation hire bar item"
        flTrackingLabel="StartAContest"
        [exactLink]="true"
      >
        Start a Contest
      </app-bar-item>
      <app-bar-item
        *flFeature="Feature.LOCAL_JOBS"
        link="/local"
        i18n="Secondary navigation hire bar item"
        flTrackingLabel="PostALocalJob"
        [exactLink]="true"
      >
        Post a Local Job
      </app-bar-item>
      <app-bar-item
        *flFeature="Feature.SHOWCASE"
        link="/showcase"
        i18n="Secondary navigation hire bar item"
        flTrackingLabel="Showcase"
        [exactLink]="true"
      >
        Showcase
      </app-bar-item>
      <app-bar-item
        *flFeature="Feature.SEARCH_POOLS"
        link="/freelancers"
        i18n="Secondary navigation hire bar item"
        flTrackingLabel="BrowseDirectory"
        [exactLink]="true"
      >
        Browse Directory
      </app-bar-item>
      <app-bar-item
        link="/recruiter"
        i18n="Secondary navigation hire bar item"
        flTrackingLabel="GetARecruiter"
        [exactLink]="true"
      >
        Get a Recruiter
      </app-bar-item>
      <app-bar-item
        *flFeature="Feature.COMMUNITY"
        link="/community"
        i18n="Secondary navigation hire bar item"
        flTrackingLabel="Community"
        [exactLink]="true"
      >
        Community
      </app-bar-item>
    </app-bar>
  `,
})
export class NavigationSecondaryHireFreelancersComponent {
  ButtonColor = ButtonColor;
  Feature = Feature;
}
